import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';

import { SearchView } from '../../types';

export const useListingSelectors = () => {
  const { listingsState } = ListingsContext.useContext();

  const getListingCount = () => {
    return listingsState.listingsResult.listings.total || 0;
  };

  const getListings = () => {
    return listingsState.listingsResult.listings.listings;
  };

  const getFeaturedListings = () => {
    if (listingsState.filterResult.filters.searchview === SearchView.Map) {
      return [];
    }
    return listingsState.listingsResult.listings.topAdListings;
  };

  const getNearbyListings = () => {
    if (listingsState.filterResult.filters.searchview === SearchView.Map) {
      return [];
    }
    return listingsState.listingsResult.listings.nearbyListings;
  };

  const isLoading = () => {
    return listingsState.listingsResult.isLoading;
  };

  return {
    getListingCount,
    getListings,
    getFeaturedListings,
    getNearbyListings,
    isLoading,
  };
};
